import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../material.module';
import { StockEntryRoutingModule } from './stock-entry.routes';
import { LotsComponent } from './pages/lots/lots.component';
import { CreateLotComponent } from './pages/create-lot/create-lot.component';
import { StockEntryComponent } from './stock-entry.component';
import { DivergenceDialogComponent } from './dialogs/divergence-dialog.component';
import { RemoveWaybillItemDialogComponent } from './dialogs/remove-waybill-item-dialog.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { CreateBagComponent } from './pages/create-bag/create-bag.component';
import { ReceivingWaybillComponent } from './pages/receiving-waybill/receiving-waybill.component';
import { BatchDeliveryComponent } from './pages/batch-delivery/batch-delivery.component';
import { Charging } from './pages/charging/charging.component';

@NgModule({
  declarations: [LotsComponent, CreateLotComponent, StockEntryComponent, DivergenceDialogComponent, CreateBagComponent, ReceivingWaybillComponent, RemoveWaybillItemDialogComponent, BatchDeliveryComponent, Charging],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    StockEntryRoutingModule,
    NgxQRCodeModule,
  ],
  exports: [StockEntryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StockEntryModule {}
